import './PreventiveFiltersTools.scss';

import { useApplyFilters } from "../../../../../hooks/useApplyFilters";

import FilterAltOff from "@mui/icons-material/FilterAltOff";

import { TextButton } from "../../../../../common-components/Buttons/Buttons";

const PreventiveFiltersTools = () => {
    const componentId = "preventive";
    const { clearFiltersParams } = useApplyFilters({componentId});

    return (
        <div className={"preventive-filters-tools"}>
            <div className={"preventive-filters-tools_container"}>
                <TextButton title={"Сбросить фильтры"} Icon={FilterAltOff} color={"#f44336"} active={true} onClick={clearFiltersParams}/>
            </div>
        </div>
    )
}

export default PreventiveFiltersTools;